import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * The phone app shell (bottom tabs, compact header, sheets instead of popovers,
 * pull to refresh) applies below this width. Wider screens keep the desktop
 * layout exactly as it was: every phone rule hangs off this one query, in JS
 * (useIsMobileApp, MOBILE_SX) and in CSS (mobile-app.css, same number).
 */
export const MOBILE_APP_MEDIA = '(max-width: 767.98px)';

/** The same breakpoint as an sx key: `sx={{ height: 86, [MOBILE_SX]: { height: 56 } }}`. */
export const MOBILE_SX = `@media ${MOBILE_APP_MEDIA}`;

/** True on a phone-width screen. noSsr reads the query on the first render, so the shell never flashes. */
export function useIsMobileApp(): boolean {
  return useMediaQuery(MOBILE_APP_MEDIA, { noSsr: true });
}

/**
 * Full-screen task pages (a lesson, an assessment, the program builders) hide
 * the bottom tabs, the way a native app pushes a screen over its tab bar.
 */
const IMMERSIVE_ROUTES = [
  /^\/app\/home\/mentee(-classic)?\/level\//,
  /^\/app\/home\/elliott-lesson/,
  /^\/app\/assessment(\/|$)/,
  /^\/app\/new-program(\/|$)/,
  /\/designer(\/|$)/,
  /\/aimd-v2(\/|$)/
];

export function isImmersiveRoute(pathname: string): boolean {
  return IMMERSIVE_ROUTES.some((re) => re.test(pathname));
}
